// extracted by mini-css-extract-plugin
module.exports = {"errorMessageWiget":"ErrorMessageWiget_errorMessageWiget__265CD","header":"ErrorMessageWiget_header__joGAB","icon":"ErrorMessageWiget_icon__kbpaj"};